export const FETCH_VEHICLE_VARIANTS = 'FETCH_VEHICLE_VARIANTS';

export const fetchVehicleVariants = () => {
    return {
        type: FETCH_VEHICLE_VARIANTS,
    };
};
